exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2SzV72RmTpb3LzIMDV6ohp {\n  display: inline-block;\n  width: 55px;\n  margin-left: 15px;\n  margin-right: 15px;\n  color: #666666;\n  user-select: none;\n  text-align: right;\n  min-width: 40px;\n  cursor: pointer;\n  text-decoration: none;\n  padding-right: 1em\n}\n\n._2SzV72RmTpb3LzIMDV6ohp::before {\n  content: attr(id);\n}\n\n._3eOa0dfImbtQFV2IyZT5Yk {\n  color: #ffffff;\n}\n", ""]);

// exports
exports.locals = {
	"lineNumber": "_2SzV72RmTpb3LzIMDV6ohp",
	"lineNumberHighlight": "_3eOa0dfImbtQFV2IyZT5Yk _2SzV72RmTpb3LzIMDV6ohp"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--4-1!./src/components/LineNumber/index.module.css
// module id = 12
// module chunks = 0 1 2 6